import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to track page views on route changes in React Router SPA.
 * Place this in your main App component or layout component.
 */
export function useSnowplowPageTracking(): void {
    const location = useLocation();

    useEffect(() => {
        // Track page view on route change (SPA navigation)
        if (window.snowplow) {
            window.snowplow('trackPageView');
        }
    }, [location.pathname, location.search]);
}
